import React from "react";
import loader from "../../Assets/images/loader.gif";

const Loading = () => {
  return <img alt="Loader" style={{ width: "3%" }} src={loader} />;
};

export default Loading;
